<div *ngIf="nestedReference$ | async as nestedReference">
  <div *ngIf="nestedReference.length > 0"
       data-cy="mb-related-products"
       [ngClass]="{'tw-border-solid tw-border-0 tw-border-t tw-border-grey-400' : showBorder}">
      <h3 class="tw-mb-8 tw-mt-0 tw-text-xl tw-text-center" [ngClass]="{'tw-mt-12' : showBorder}">{{title | mbTranslate}}
        <span [innerHTML]="localTitle$ | async | safeHtml"></span>
      </h3>
    <cx-carousel
      data-cy="mb-related-products-carousel"
      [items]="nestedReference"
      [itemWidth]="itemWidth"
      [indicatorIcon]="indicatorIcon"
      [template]="carouselItem"
    >
    </cx-carousel>
    <ng-template #carouselItem
                 let-item="item">
      <div class="tw-flex tw-flex-col tw-items-center tw-h-full tw-text-center">
        <cx-media [container]="item?.target?.images?.GALLERY"
                  format="product"
                  [alt]="item?.target?.name"
                  class="media">
        </cx-media>
        <div class="tw-mt-2 tw-min-h-6">
          <span *ngIf="showProductCode(item)"
             class="text"
             [innerHTML]="item?.target?.code"></span>
        </div>
        <a tabindex="0"
           [routerLink]="getRouterLink(item?.target?.url)"
           [fragment]="getFragment(item?.target?.url)"
           [attr.data-cy]="'mb-related-products-item-' + item?.target?.code"
           (click)="clearDataFromFilterProductService()">
          <strong [innerHTML]="item?.target?.nameHtml | safeHtml"
                  [mbProductClick]="item?.target"
                  [attr.data-analytics-src]="dataAnalyticsClickSource">
          </strong>
        </a>
        <div class="tw-mt-auto tw-w-full">
          <div class="tw-mt-2">
            <ng-container *ngIf="item?.target?.price && !item?.target?.priceOnRequest; else onRequest">
              <strong [innerHTML]="item?.target?.price?.formattedValue"></strong>
            </ng-container>
            <ng-template #onRequest>
              <strong>{{ 'mbcommon.onRequest' | mbTranslate }}</strong>
            </ng-template>
          </div>
          <div class="tw-mt-4 tw-text-sm button-wrapper">
            <ng-container *ngIf="item?.target?.baseProduct; else isProduct">
              <span class="btn btn-primary"
                    (click)="addToCart(item?.target?.code)">
                {{ (item?.target?.priceOnRequest ? 'addToCart.requestPrice' : 'addToCart.addToCart') | mbTranslate }}
              </span>
            </ng-container>
            <ng-template #isProduct>
              <span class="btn btn-secondary"
                    [routerLink]="getRouterLink(item?.target?.url)"
                    [fragment]="getFragment(item?.target?.url)">
                    {{'addToCart.viewProduct' | mbTranslate}}
                  </span>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
